import { Instance } from "../../Base";
import Decorator from "../Decorator";

export default class HideCheckboxDecorator extends Decorator {
  constructor(component: Instance) {
    super(component);

    const container = component.element.parentElement?.parentElement;
    if (container) {
      container.style.display = "none";
    }
  }
}
